if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (!this.form) return;

        var idInput = this.form.querySelector("[name=id]");
        if (idInput) idInput.disabled = false;

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        this.cart = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (this.cart && this.submitButton) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton || this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        var spinner = this.querySelector(".loading-overlay__spinner");
        if (spinner) spinner.classList.remove("hidden");

        var config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";

        var formData = new FormData(this.form);
        var mainVariantId = formData.get("id");
        var mainQuantity = Number(formData.get("quantity") || 1);

        var bundleCheckbox = this.form.querySelector("[data-tokbolt-bundle-checkbox]");
        var bundleVariantId = bundleCheckbox ? bundleCheckbox.getAttribute("data-variant-id") : "";
        var shouldAddBundle =
          bundleCheckbox &&
          bundleCheckbox.checked &&
          !bundleCheckbox.disabled &&
          bundleVariantId;

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        if (shouldAddBundle) {
          var mainItem = {
            id: Number(mainVariantId),
            quantity: mainQuantity
          };

          var sellingPlan = formData.get("selling_plan");
          if (sellingPlan) {
            mainItem.selling_plan = Number(sellingPlan);
          }

          var payload = {
            items: [
              mainItem,
              {
                id: Number(bundleVariantId),
                quantity: 1
              }
            ]
          };

          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map(function (section) {
              return section.id;
            });
            payload.sections_url = window.location.pathname;
          }

          config.headers["Content-Type"] = "application/json";
          config.body = JSON.stringify(payload);
        } else {
          delete config.headers["Content-Type"];

          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map(function (section) {
                return section.id;
              })
            );

            formData.append("sections_url", window.location.pathname);
          }

          config.body = formData;
        }

        fetch(routes.cart_add_url, config)
          .then(function (response) {
            return response.json();
          })
          .then(
            function (response) {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: mainVariantId,
                  errors: response.description,
                  message: response.message
                });

                this.handleErrorMessage(response.description);

                var soldOutMessage = this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;

                this.submitButton.setAttribute("aria-disabled", true);

                var buttonSpan = this.submitButton.querySelector("span");
                if (buttonSpan) buttonSpan.classList.add("hidden");

                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: mainVariantId
                });
              }

              this.error = false;

              var quickAddModal = this.closest("quick-add-modal");

              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  function () {
                    setTimeout(
                      function () {
                        this.cart.renderContents(response);
                      }.bind(this)
                    );
                  }.bind(this),
                  { once: true }
                );

                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            }.bind(this)
          )
          .catch(function (e) {
            console.error(e);
          })
          .finally(
            function () {
              this.submitButton.classList.remove("loading");

              if (this.cart && this.cart.classList.contains("is-empty")) {
                this.cart.classList.remove("is-empty");
              }

              if (!this.error) {
                this.submitButton.removeAttribute("aria-disabled");
              }

              var spinner = this.querySelector(".loading-overlay__spinner");
              if (spinner) spinner.classList.add("hidden");
            }.bind(this)
          );
      }

      handleErrorMessage(errorMessage) {
        errorMessage = errorMessage || false;

        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}